import {useMixpanel, UseMixpanelProps} from '.';

export const Mixpanel = (props: UseMixpanelProps) => {
  useMixpanel(props);
  return null;
};
